/**
 * Consume an SSE (EventSource-style) response body created by fetch().
 * Yields parsed `data:` payloads keyed by `event: <name>` — default `message`.
 *
 * Errors from the "error" event are thrown so the caller can toast them.
 * Callers pass an `onData(event, payload)` handler. The generator awaits the
 * body reader until `done`.
 */
export async function consumeSSE(response, onData) {
  if (!response.ok || !response.body) throw new Error(`Stream failed to start (${response.status})`);
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) return;
    buffer += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buffer.indexOf("\n\n")) !== -1) {
      const raw = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      const lines = raw.split("\n");
      let event = "message";
      let payload = "";
      for (const l of lines) {
        if (l.startsWith("event: ")) event = l.slice(7).trim();
        else if (l.startsWith("data: ")) payload += l.slice(6);
      }
      if (event === "error") {
        try { const p = JSON.parse(payload); throw new Error(p.detail || "Stream error"); }
        catch (e) { throw e; }
      }
      if (event === "done") continue;
      onData(event, payload);
    }
  }
}

/** Extract code from a Markdown fenced block (```mql4/mq4/cpp/c). */
export function stripFence(raw) {
  const m = raw.match(/```(?:mql4|mq4|mql5|mq5|cpp|c\+\+|c)?\s*\n([\s\S]*?)(?:```|$)/i);
  return m ? m[1] : raw;
}
